import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ProdInvData } from './prod-inv.dto';

export class AllProdInvResponseModel extends GlobalResponseObject{
    data?: ProdInvData[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProdInvData
     */
     constructor(status: boolean, intlCode: number, internalMessage: string, data?: ProdInvData[]) {
        super(status, intlCode, internalMessage);
        this.data = data;
    }    
}
